<template>
    <div>
        <div class="typo text-center">
            <h1 class="smaller">
                Dziękujemy za wypełnienie <br>
                formularza rejestracji!
            </h1>
            <br>
            <p>
                Numer Twojej wirtualnej karty MAKRO, otrzymasz po zakończeniu
                kampanii rejestracyjnej.
            </p>
            <p>
                Otrzymasz powiadomienie na e&#8209;mail podany w fomularzu rejestracji.
            </p>

            <hr/>
            <!--<p>
                <img src="@/assets/images/logo.png" alt="makro.pl" /><br>
                <a href="https://www.makro.pl" target="_blank" rel="noopener" >
                    www.makro.pl
                </a>

            </p>-->
        </div>
        <CampaignIntro header-class="text-center smaller" header-tag="h2"/>
        <div class="typo text-center">
            <hr>
            <h3 class="smaller">
                Jak rozpocząć zakupy?
            </h3>
            <p v-bastards>
                Pobierz aplikację na swój telefon i korzystaj z wirtualnej Karty Klienta.
            </p>
            <p >
                <a href="https://play.google.com/store/apps/details?id=pl.itcraft.makroapp&hl=pl" style="text-decoration: none; border: 0;">
                    <img
                        src="@/assets/images/app-google.png"
                        style="width: 196px; height: 58px; border: 0;"
                        alt="Pobierz z Google Play"
                        width="196"
                        height="58"
                    />
                </a>
                &nbsp;
                <a href="https://apps.apple.com/pl/app/makro/id1146761397?l=pl"  style="text-decoration: none; border: 0;">
                    <img
                        src="@/assets/images/app-apple.png"
                        style="width: 196px; height: 58px; border: 0;"
                        alt="Pobierz w App Store"
                        width="196"
                        height="58"
                    />
                </a>

            </p>
        </div>
    </div>

</template>

<script>
    import CampaignIntro from '@/components/page/campaign/CampaignIntro'
    export default {
        name: "CampaignDone",
        components: {CampaignIntro}
    }
</script>

<style>

</style>
